import { openBlock as t, createElementBlock as h, createStaticVNode as l } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, e = /* @__PURE__ */ l('<path fill="#A2001D" d="M40 20c0 11.046-8.954 20-20 20S0 31.046 0 20 20 0 20 0s20 8.954 20 20Z"></path><path fill="#0052B4" d="M0 20C0 8.954 8.954 0 20 0s20 8.954 20 20"></path><path fill="#F0F0F0" d="M26.956 25.217 20 24.347l-6.957.87V14.783h13.913v10.434Z"></path><path fill="#0052B4" d="M20 24.348a3.478 3.478 0 1 0 0-6.957 3.478 3.478 0 0 0 0 6.957Z"></path><path fill="#A2001D" d="M20 22.609a1.74 1.74 0 1 0 0-3.479 1.74 1.74 0 0 0 0 3.479Z"></path><path fill="#6DA544" d="M17.391 16.522h5.218l-2.61 2.608-2.608-2.608Z"></path><path fill="#FFDA44" d="M19.13 18.26h1.74v5.218h-1.74v-5.217Z"></path><path fill="#6DA544" d="M22.782 22.956h-5.565l-4.174 2.261h13.913l-4.174-2.26Z"></path>', 8), p = [
  e
];
function i(o, d) {
  return t(), h("svg", a, [...p]);
}
const n = { render: i };
export {
  n as default,
  i as render
};
